import { useBreadcrumb } from "features/breadcrumbs";
import ContentDocumentos from "components/ContentDocumentos";

export default function ListagemDocumentos() {
  useBreadcrumb([
    { name: "Administração", url: "" },
    { name: "Administrativo", url: "" },
    { name: "Documentos", url: "/cadastros/documentos" },
  ]);
  return <ContentDocumentos title="Documentos" midComponent={true} />;
}
